import React, { useEffect, useState } from 'react';
import { Typography } from '@telus-uds/components-web';

import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import ErrorIcon from '../../../../../assets/images/icon_error_messages.gif';
import { sortedObjects } from '../../../../utils/utils';
import Label from './label';

const DealershipField = ({
  label,
  errors,
  touched,
  values,
  defaultVal,
  setFieldValue,
  dealershipNames
}) => {
  const dealershipList = sortedObjects(dealershipNames, 'name').map(
    ({ id, name }) => {
      return { id, label: name };
    }
  );
  const [selected, setSelected] = useState();
  useEffect(() => {
    if (values && values.dealership && values.dealership[0])
      setSelected(dealershipList.filter(l => l.id === values.dealership[0].id));
  }, [defaultVal]);

  return (
    <>
      <Label labelName={label} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${errors.dealership && touched.dealership ? 'error' : ''
          }`}
      >
        <Typeahead
          id="single-typehead"
          labelKey="label"
          name="dealership"
          options={dealershipList}
          onChange={selectedValue => {
            setSelected(selectedValue);
            setFieldValue(selectedValue);
          }}
          placeholder="Select dealership"
          selected={selected}
          clearButton
        />
        <>
          <div className="error_messages">
            <Typography variant={{ colour: 'error' }}>{errors.dealership}</Typography>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

DealershipField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  dealershipNames: PropTypes.isRequired
};

export default DealershipField;
